import React from "react"
import { connect } from "react-redux"
import AuthActions from "redux-store/models/auth"
import LoginComponent from "routes/domains/Login"
import images from "themes/images"

class Login extends React.Component {
  componentDidMount() {
    if (localStorage.getItem("accountDataB")?.includes("object")) {
      localStorage.setItem("accountDataB", null)
    }
  }

  render() {
    const isMrPayCard = process.env.REACT_APP_IS_MRPAY_CARD === "true"

    const pageStyle = {
      position: "relative",
      display: "flex",
      minHeight: "100vh",
      backgroundImage: `url(${images["mrpaycard-bg"]})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }

    const overlayStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: isMrPayCard ? "rgba(0, 0, 0, 0.5)" : "transparent",
    }

    const contentWrapperStyle = {
      display: "flex",
      flex: 1,
      width: "100%",
      position: "relative",
      zIndex: 2,
    }

    const leftHalfStyle = {
      flex: 1,
    }

    const rightHalfStyle = {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }

    const loginContainerStyle = {
      maxWidth: "600px",
      width: "100%",
    }

    return (
      <div className="login-component" style={pageStyle}>
        <div style={overlayStyle} />

        <div style={contentWrapperStyle}>
          <div style={leftHalfStyle} />

          <div style={rightHalfStyle}>
            <div className="module container-fluid" style={loginContainerStyle}>
              <LoginComponent />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapsStateToProps = ({ auth }) => ({})

export default connect(mapsStateToProps, {
  ...AuthActions,
})(Login)
